import React from "react";
import { Row, Col } from "react-bootstrap";
import { searchParty } from "../../../Utils/searchParty";
import getAge from "../../../Utils/Date/getAge";
import "./HeaderInfo.css";

var formatter = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export function HeaderInfoVehicle({ oportunity, justified }) {
  const RiskIn = oportunity.risk_in;
  const getSubtitle = React.useCallback((word) => {
    if (!word) return;
    return word
      .toLowerCase()
      .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
  }, []);
  //! Información de asegurado y vehículo
  const [partieInfo] = React.useState([
    //! Asesor
    {
      Asesor: oportunity?.broker?.name ? oportunity?.broker?.name : "",
      Email: oportunity?.broker?.email ? oportunity?.broker?.email : "",
      Teléfono: oportunity?.broker?.phone || "",
      Celular: oportunity?.broker?.mobile || "",
    },
    // ! Asegurado
    {
      Asegurado:
        searchParty(oportunity, "Asegurado").party_type === "person" ? (
          <span>
            {searchParty(oportunity, "Asegurado").person.firstname +
              " " +
              searchParty(oportunity, "Asegurado").person.lastname}
          </span>
        ) : (
          <span>{searchParty(oportunity, "Asegurado").organization.name}</span>
        ),
      Identificación:
        searchParty(oportunity, "Asegurado").party_type === "person" ? (
          <span>
            {searchParty(oportunity, "Asegurado").person?.identification_number}
          </span>
        ) : (
          <span>
            {
              searchParty(oportunity, "Asegurado").organization
                ?.identification_number
            }
          </span>
        ),
      Edad:
        RiskIn.parties[0].party_type === "person" ? (
          <span>{getAge(RiskIn?.parties?.[0]?.person?.birht_date)}</span>
        ) : (
          <span>NA</span>
        ),
      Género:
        RiskIn.parties[0].party_type === "person" ? (
          <span>{RiskIn?.parties?.[0].person?.gender}</span>
        ) : (
          <span>NA</span>
        ),
    },
  ]);
  const [objDescription] = React.useState(() => {
    let desc = RiskIn.insurable_objects[0].description
      ? RiskIn.insurable_objects[0].description
      : "";
    if (RiskIn.insurable_objects[0].type === "vehicle" && desc !== "") {
      desc += `<span class="vehicle-circulation" style="margin-right:5px">
      <span>
      <strong>Circulación: </strong>
      </span>
      <span>${
        getSubtitle(RiskIn.ubication.place.city_name) +
        "-" +
        RiskIn.ubication.place.state_name
      }</span>
    </span`;
    }
    return desc;
  });
  const fontSize = "6px";
  const fontSizeTitle = "8px";
  const fontSizeSubTitle = "0.8em";

  return (
    <Row style={{ margin: "0 0 0 0", paddingRight: 0, width: "100%" }}>
      <Col style={{ padding: 0, margin: 0 }}>
        {partieInfo.map((obj, idx) => (
          <Row
            key={idx}
            style={{
              fontSize: fontSizeSubTitle,
              margin: "1em 0 0 0",
              paddingRight: 0,
            }}
          >
            <span
              className={justified ? "" : "text-center"}
              style={{ paddingLeft: "0px", display: "flex", flexWrap: "wrap" }}
            >
              {Object.entries(obj).map(
                ([key, value], idx) =>
                  value && (
                    <span className="header_line_info" key={idx}>
                      <span>
                        <strong>{key}: </strong>
                      </span>
                      <span style={{ marginBottom: "0.3em" }}>{value}</span>
                    </span>
                  )
              )}
            </span>
          </Row>
        ))}
        {objDescription && (
          <Row
            className={"obj-description"}
            style={{
              fontSize: fontSizeSubTitle,
              margin: "1em 0 0 0",
              paddingRight: 0,
            }}
          >
            <div
              style={{ paddingLeft: "0px" }}
              dangerouslySetInnerHTML={{ __html: objDescription }}
            ></div>
          </Row>
        )}
      </Col>
    </Row>
  );
}
